import { FC, ReactNode } from 'react'

interface Props {
  children?: ReactNode
  condition?: boolean
  falseWrapper?(children: ReactNode): ReactNode
  wrapper(children: ReactNode): ReactNode
}

export const ConditionalWrapper: FC<Props> = ({ condition, wrapper, falseWrapper, children }) =>
  condition ? wrapper(children) : falseWrapper?.(children) ?? children
